// extracted by mini-css-extract-plugin
export default {"codeEditorBox":"Wrapper_codeEditorBox__MILX5","content":"Wrapper_content__UtMZc","isCodeContent":"Wrapper_isCodeContent__MsGDg","button":"Wrapper_button__pNvH7"};